<div class="modal-header">
  <h4 class="modal-title pull-left" *ngIf="isNewProgramme">Nouveau programme</h4>
  <h4 class="modal-title pull-left" *ngIf="!isNewProgramme">Modification du programme</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" onkeydown="return event.key != 'Enter';" autocomplete="off" role="presentation">
  <div class="modal-body">

    <div class="form-group required">
      <label for="diplome" class="control-label">Sanction</label>
      <div class="input-group">

        <select formControlName="diplome"
                id="diplome"
                name="diplome"
                required
                class="form-control"
                [(ngModel)]="programme.diplome">
          <option value="null" disabled>...</option>
          <option value="AEP">AEP - Attestation d'études professionnelles</option>
          <option value="ASP">ASP - Attestation de spécialisation professionnelle</option>
          <option value="DEP">DEP - Diplôme d'études professionnelles</option>
          <option value="AEC">AEC - Attestation d'études collégiales</option>
          <option value="DEC">DEC - Diplôme d'études collégiales</option>
        </select>
      </div>
    </div>

    <div class="form-group required">
      <label class="control-label" for="code">Code</label>
      <input type="text" class="form-control format-code" id="code" placeholder=""
             (input)="verifierSiCodeValide($event.target.value)"
             formControlName="code"
             [(ngModel)]="programme.code" />
    </div>

    <p [hidden]="!afficherMessage"
       class="bg-danger">Ce code de programme existe d&eacute;j&agrave;!</p>

    <div class="form-group required">
      <label class="control-label" for="nom">Nom</label>
      <input type="text" class="form-control" id="nom" placeholder="" formControlName="nom" [(ngModel)]="programme.nom" />
    </div>

    <div hidden class="form-group" *ngIf="!isNewProgramme">
      <label for="isActif">Programme actif?&nbsp;</label>
      <input type="checkbox" id="isActif" formControlName="isActif" [(ngModel)]="programme.isActif" />
    </div>

  </div>

  <div class="modal-footer">
    <!--<button *ngIf="!isNewProgramme" type="button" class="btn btn-danger" style="position:absolute; left:11px;"
            [disabled]="isLoading" data-toggle="modal" data-target="#staticBackdrop">
      Supprimer
    </button>-->
    <button type="submit" class="btn btn-info" [disabled]="!form.valid || form.pristine || isLoading || !codeValide">
      <span [style.display]="isLoading ? 'inline-block' : 'none'" class="fa fa-refresh spinning"></span>
      Sauvegarder
    </button>
    <button type="button" class="btn btn-default" [disabled]="isLoading" (click)="cancel()">Annuler</button>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">Suppression du programme</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          Attention! Cette action est irr&eacute;versible...<br />
          Vous pouvez simplement d&eacute;sactiver le programme si vous ne souhaitez plus le voir dans les tableaux d’harmonisation.
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" (click)="supprimer()">Supprimer</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
        </div>
      </div>
    </div>
  </div>

</form>
